<ng-container *ngIf="accessibility$ | async as accessibility">
  <mat-toolbar style="background: transparent;justify-content: end">
    <app-accessibility ></app-accessibility>
  </mat-toolbar>
</ng-container>
<form (ngSubmit)="login()" #loginForm1="ngForm"
      fxLayoutAlign="center" fxLayout="column"
      *ngIf="!modeAnonyme">
  <mat-card appearance="outlined" class="alert-warning" *ngIf="message">
    <mat-card-content fxLayout="row">
      {{message.message}}
      <button mat-icon-button class="button-warning" fxFlex fxLayoutAlign="end" (click)="closeAlert()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" class="panel-single">
    <div *ngIf="applicationName" class="mat-subtitle-1 app-cm_login__title">{{ applicationName }}</div>
    <div class="mat-subtitle-1 app-cm_login__title">CONNEXION</div>

    <mat-card-content>
      <div class="left-content">
        <img style="width: 280px;"/>
      </div>
      <div class="right-content">
        <mat-form-field fxLayout="row" class="login-input" appearance="outline">
          <mat-icon matPrefix>person</mat-icon>
          <input matInput placeholder="Identifiant"
                 name="username"
                 required
                 type="text"
                 [(ngModel)]="model.username" data-cy="input-login-username">
        </mat-form-field>

        <mat-form-field fxLayout="row" class="login-input" appearance="outline">
          <mat-icon matPrefix>lock</mat-icon>
          <input matInput placeholder="Mot de passe" name="password" type="password" required
                 [(ngModel)]="model.password" data-cy="input-login-password">

        </mat-form-field>
      </div>

    </mat-card-content>
    <mat-card-actions>
      <div class="left-action">
        <span class="line">
          <ng-container *ngIf="application === accessToApplication.ater_candidature">
            <a href="javascript: void(0);" (click)="downloadFile()">Télécharger le mode opératoire</a>
            &nbsp;|&nbsp;
          </ng-container>
          <a href="javascript: void(0);" (click)="resetPwd()">Mot de passe oublié</a>
        </span>
        <span class="line">Université Paris 8 VINCENNES SAINT-DENIS</span>
      </div>
      <div class="right-action">
        <button class="login-button" mat-raised-button
                [disabled]="! canValidate()"
                type="submit"
                [color]="'primary'" data-cy="button-login-connection">Connexion
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</form>
